import { delay, fork, takeEvery } from 'saga-ts';
import { l } from 'shared-base';

export const saga = {
  id: 'sloyd.quality',
  type: 'entity',
  root: root,
  trigger: {
    actionTypes: ['squality'],
  },
};

type Verb =
  | 'fetchAll' //
  | 'rate';

const map: Record<Verb, any> = {
  fetchAll: fetchAll,
  rate: rate,
};

export function* fetchAll(action: any) {
  const { payload } = action;

  try {
  } catch (err) {
    console.log('err =>', err);
  }
}

export function* rate(action: any) {
  try {
  } catch (err) {
    console.log('err =>', err);
  }
}

export function* quality(action: any) {
  const { verb } = action;

  yield delay(10);

  const saga = (map as any)[verb];

  if (!saga) {
    return;
  }

  l(`saga|saga.quality ${verb}`);

  yield* fork(saga, action);
}

export function* root() {
  yield takeEvery('QUALITY', quality);
}
